module.exports = __webpack_public_path__ + "static/assets/f3e8aa205c0cf65ba99922ce1f3fc94e.gif";